const styles = {
  modal: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    outline: "none",
  },
  card: {
    width: 450,
    borderRadius: 3,
    boxShadow: "0 12px 32px rgba(0,0,0,0.12)",
    padding: "20px",

  },
  header: {
    fontWeight: 600,
  },
  label: {
    fontWeight: 500,
    mb: 1,
  },
  subSection: {
    mt: 3,
    p: 2,
    borderRadius: 2,
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
  subHeader: {
    fontWeight: 600,
    mb: 1,
    color: "text.secondary",
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: 1,
    mt: 3,
  },
};

export default styles;